import "./styles.css";

export const ConfirmationModal = ({ buyLink, setDisplayModal, displayModal }) => {

  return (
    <>
      <div className="Alert">
        Realmente deseja acessar?
        <div>Você será redirecionado para outro site.</div>
        <div className="botoes">
          <button
            className="etiqueta-cancelar"
            onClick={() => setDisplayModal(!displayModal)}
          >
            Cancelar
          </button>
          <a 
            href={buyLink}
            target="_blank"
            rel="noopener noreferrer"
            className="etiqueta-prosseguir"
            onClick={() => setDisplayModal(!displayModal)}
          >
            Prosseguir
          </a>
        </div>
      </div>
    </>
  );
};
